import { useBeforeUnloadOrHashChange, useSetState } from '@domain-group/react-hooks'

import { Box, DashboardModule, FileUploadZone } from '@domain-group/suit-theme'

import useUppyImageUpload from '@hooks/useUppyImageUpload'

const defaultState = {
  busy: false,
}

interface UploadImagesProps {
  campaignId: number,
}

const UploadImages = (props: UploadImagesProps) => {
  const { campaignId } = props

  const [state, setState] = useSetState(defaultState)
  const { busy } = state

  // Block Navigation when busy uploading
  useBeforeUnloadOrHashChange({
    enabled: busy,
    message: 'Images are still uploading! Are you sure you want to leave this page?',
  })

  const uppy = useUppyImageUpload(
    {
      allowedFileTypes: 'image/*,application/pdf',
      callbacks: {
        afterAction: () => setState({ busy: false }),
        beforeAction: () => setState({ busy: true }),
      },
      image_type: 'photo',
      imageable_id: campaignId,
      imageable_type: 'Campaign',
      requestOptions: {
        include_image_sizes: true,
      },
    },
    // @ts-expect-error TS2322
    [campaignId],
  )

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      title="Upload"
    >
      <Box padding="large">
        <FileUploadZone uppy={uppy} />
      </Box>
    </DashboardModule>
  )
}

export default UploadImages
